import { Menu } from "@mantine/core";
import { HeldEmailReleaseActions } from "./HeldEmailReleaseActions";
import { HeldEmailViewActionItem } from "./HeldEmailViewActionItem";
import { HeldEmailRowActionsModel } from "./heldEmailRowActionsModel";

export function HeldEmailRowActionsDropdown({
  model,
}: {
  model: HeldEmailRowActionsModel;
}) {
  return (
    <Menu.Dropdown>
      <HeldEmailViewActionItem
        heldEmailId={model.heldEmailId}
        onView={model.onView}
      />
      <HeldEmailReleaseActions model={model} />
    </Menu.Dropdown>
  );
}
